"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _NavigationCollapseWrapper = _interopRequireDefault(require("./NavigationCollapseWrapper"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var NavigationCollapse = function NavigationCollapse(_ref) {
  var id = _ref.id,
    isOpened = _ref.isOpened,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_NavigationCollapseWrapper["default"], {
    id: id,
    "in": isOpened,
    navigationExpanded: isOpened,
    "aria-expanded": isOpened
  }, children);
};
NavigationCollapse.propTypes = process.env.NODE_ENV !== "production" ? {
  id: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].node,
  isOpened: _propTypes["default"].bool
} : {};
NavigationCollapse.defaultProps = {
  isOpened: false
};
var _default = exports["default"] = NavigationCollapse;